import { Controller } from "@hotwired/stimulus";

// Shows the one panel that matches the checked radio in a group and hides the rest — for a "pick a mode, then
// fill in that mode's control" form (the promotion page's "Takes off" and "Applies to" cards). Panels stay in
// the DOM rather than being removed, because a hidden input still submits: the server sees every candidate and
// can deal with the abandoned one deliberately (e.g. zeroing the discount the operator switched away from)
// instead of guessing.
//
// Wire it on the element that wraps the radios and the panels:
//   data-controller="admin--radio-panels"
//   data-admin--radio-panels-name-value="record[discount_kind]"
//   data-action="change->admin--radio-panels#sync"
// and tag each panel with data-admin--radio-panels-target="panel" plus data-panel-value="<its radio value>".
// A panel whose value matches nothing simply stays hidden. Subclass it when a mode switch has to do more than
// swap panels.
export default class extends Controller {
  static targets = ["panel"];
  static values = { name: String };

  connect() {
    this.sync();
  }

  sync() {
    const picked = this.pickedValue;
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.panelValue !== picked);
    });
    // Swapping panels changes the content's height. An ancestor accordion may still carry the
    // fixed inline height its open transition measured (normally cleared on transitionend, which
    // a quick toggle can interrupt) — drop the stale measurement so the section re-flows instead
    // of clipping the taller panel.
    this.element.closest(".st-accordion__content")?.style.removeProperty("height");
  }

  get pickedValue() {
    return this.element.querySelector(`input[name="${this.nameValue}"]:checked`)?.value;
  }
}
